var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mb-0",staticStyle:{"border":"0 !important"},attrs:{"icon":"mdi-information-outline","type":_vm.type,"outlined":"","dense":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }